import React, { useEffect, useState } from 'react';
import { Slide, Grid } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import RequestAccessToken from "../../util/authService";
import BarChartIcon from '@material-ui/icons/BarChart';
import { refMDLoaded, practiceCoordinatorLoaded, shouldTryRefMDProfile, shouldTryCareCoordinatorProfile } from '../common/ProfileHelper'


type NextSiteOfCareStatsProps = APIStore.HNIContextState &
    typeof APIStore.actionCreators;

const DischargeDispositionType = (props: NextSiteOfCareStatsProps) => {
    let {
        DischargeDispositionStats,
        requestDischargeDispositionStatsForProvider,
        requestDischargeDispositionStatsForPractice,
        requestDischargeDispositionStatsForByTag,
        requestCurrentUserCareCoordinatorProfile,
        userRefMdProfile,
        requestVitalsMdProfile,
        userPracticeCoordinatorProfile,
        receiveTokenResponse,
        APIToken } = props;

    let [tokenState, setTokenState] = useState<APIStore.TokenType>();

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        ArcElement
    );

    const options = {
        indexAxis: 'y',
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Next Sites of Care'
            },
        }
    };

    let DischargeDispositions: APIStore.DischargeDispositionStatistics[] = [];


    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
                receiveTokenResponse(token);
            }
        });

    useEffect(() => {
        if (APIToken && !tokenState?.accessToken) {
            setTokenState(APIToken);
        }

    }, [APIToken, tokenState])

    useEffect(() => {
        if (shouldTryRefMDProfile(userRefMdProfile) && tokenState?.accessToken && userPracticeCoordinatorProfile.notFound) {
            requestVitalsMdProfile(tokenState.accessToken);
        }

    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile])

    useEffect(() => {
        if (shouldTryCareCoordinatorProfile(userPracticeCoordinatorProfile) && tokenState?.accessToken) {
            requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);
        }
    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile]);

    useEffect(() => {
        if ((refMDLoaded(userRefMdProfile) && tokenState?.accessToken)) {
            requestDischargeDispositionStatsForProvider(tokenState.accessToken)
        }

    }, [tokenState, userRefMdProfile]);

    useEffect(() => {
        if (!DischargeDispositionStats.isLoaded && !DischargeDispositionStats.isLoading && tokenState?.accessToken) {
            if (practiceCoordinatorLoaded(userPracticeCoordinatorProfile)) {
                requestDischargeDispositionStatsForProvider(tokenState.accessToken)
            }
        }
    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile, DischargeDispositionStats]);


    if (DischargeDispositionStats.isErrored) {
        return (<React.Fragment><p>Error Loading</p></React.Fragment>)
    }

    if (DischargeDispositionStats.isLoading || !DischargeDispositionStats.isLoaded) {
        return (
            <Slide in timeout={1000} direction="left">
                <Grid container>
                    <Grid item md={4}>
                        <BarChartIcon className="animate-flicker" style={{ fontSize: 100 }} color="disabled"></BarChartIcon>
                    </Grid>
                </Grid>
            </Slide>

        )
    }

    if (DischargeDispositionStats) {
        DischargeDispositions = DischargeDispositionStats.dischargeDispositions;
    }

    let labels = DischargeDispositions.map(val => val.typeDesciption);
    let values = DischargeDispositions.map(val => {
        return val.patientCount;
    });

    const data = {
        labels,
        datasets: [
            {
                label: "Count",
                data: values,
                backgroundColor: [
                    'rgba(82, 189, 228, 0.2)',
                    'rgba(48, 82, 98, 0.2)',
                    'rgba(165, 209, 229, 0.2)',
                    'rgba(84, 144, 174, 0.2)',
                    'rgba(71, 91, 100, 0.2)',
                    'rgba(141, 206, 233, 0.2)',
                    'rgba(125, 151, 158, 0.2)'
                ],
                borderColor: [
                    'rgb(82, 189, 228)',
                    'rgb(48, 82, 98)',
                    'rgb(165, 209, 229)',
                    'rgb(84, 144, 174)',
                    'rgb(71, 91, 100)',
                    'rgb(141, 206, 233)',
                    'rgb(125, 151, 158)'
                ],
                hoverOffset: 4,
                borderWidth: 2
            },
        ],
    };

    return (
        <React.Fragment>
            <div>
                <React.Fragment>
                    <Bar options={options} data={data}></Bar>
                </React.Fragment>
            </div>
        </React.Fragment>
    )
}


export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(DischargeDispositionType as any);